import { useState } from "react";
import CustomerPricingGroup from "./CustomerPricingGroup";
import FoamMaterialPricesPanel from "./FoamMaterialPricesPanel";
import SpringMaterialPricesPanel from "./SpringMaterialPricesPanel";

export interface MaterialPricesPanelProperties {
  customerId: number;
  priceListId: number;
}

const PricingsPanel = (props: MaterialPricesPanelProperties) => {
  const customerId = props.customerId;
  const priceListId = props.priceListId;
  const [pricingGroupId, setPricingGroupId] = useState<number>();
  const [lastViewRefresh, setLastViewRefresh] = useState<Date>();

  const handlePricingGroupAssignmentClosed = () => setLastViewRefresh(new Date());

  return <main>
    <CustomerPricingGroup
      customerId={ customerId }
      priceListId={ priceListId }
      onPricingGroupAssignmentClosed={ handlePricingGroupAssignmentClosed }
      onPricingGroupIdSet={ setPricingGroupId }
    />
    <FoamMaterialPricesPanel
      customerId={ customerId } 
      priceListId={ priceListId }
      pricingGroupId={ pricingGroupId }
      lastViewRefresh={ lastViewRefresh }
    />
    <SpringMaterialPricesPanel
      customerId={ customerId }
      priceListId={ priceListId }
    />
  </main>;
};

export default PricingsPanel;